import type { JSX, ReactNode } from 'react'

import { Flex } from '@buffer-mono/popcorn'

import { ComposerFrame } from '../ComposerFrame'

import styles from './Header.module.css'

export function ComposerHeaderLayout({
  sidePanelOpen,
  leading,
  title,
  tags,
  actions,
}: {
  sidePanelOpen: boolean
  leading?: ReactNode
  title: ReactNode
  tags: ReactNode
  actions: ReactNode
}): JSX.Element {
  return (
    <ComposerFrame.Header
      className={styles.header}
      data-sidepanel-state={sidePanelOpen ? 'open' : 'closed'}
    >
      <Flex gap="2xs" align="center">
        {leading}
        <Flex gap="sm" align="center">
          {title}
          {tags}
        </Flex>
      </Flex>
      <Flex gap="xs" className={styles.actions}>
        {actions}
      </Flex>
    </ComposerFrame.Header>
  )
}
